module.exports = __webpack_public_path__ + "static/media/kudos-like-new.afea68b7.gif";